// Mapping of tag icon names to SVG file paths
// This is a parallel version of tagIcons.json that uses SVG icons instead of emojis
// SVGs are imported as URLs and bundled into the app by Vite

// Import all SVG icons as URLs
import Icon1001 from './icons/1001_bunch_ingredients.svg'
import Icon1002 from './icons/1002_diningroom.svg'
import Icon1003 from './icons/1003_bottle_of_water.svg'
import Icon1004 from './icons/1004_wine_bottle.svg'
import Icon1005 from './icons/1005_doughnut.svg'
import Icon1006 from './icons/1006_pizza.svg'
import Icon1007 from './icons/1007_hamburger.svg'
import Icon1008 from './icons/1008_lunch.svg'
import Icon1009 from './icons/1009_deliver.svg'
import Icon1010 from './icons/1010_banana.svg'
import Icon1011 from './icons/1011_tomato.svg'
import Icon1012 from './icons/1012_cocktail.svg'
import Icon1013 from './icons/1013_sushi.svg'
import Icon1014 from './icons/1014_bakery.svg'
import Icon1015 from './icons/1015_corkscrew.svg'
import Icon1016 from './icons/1016_coffee_cup.svg'
import Icon1017 from './icons/1017_coffee_outdoor.svg'
import Icon1018 from './icons/1018_meat.svg'
import Icon1019 from './icons/1019_milk.svg'
import Icon2001 from './icons/2001_beer.svg'
import Icon2002 from './icons/2002_dancing.svg'
import Icon2003 from './icons/2003_film_reel.svg'
import Icon2004 from './icons/2004_champagne.svg'
import Icon2005 from './icons/2005_birthday.svg'
import Icon2006 from './icons/2006_candy.svg'
import Icon2007 from './icons/2007_controller.svg'
import Icon2008 from './icons/2008_books.svg'
import Icon2009 from './icons/2009_dice.svg'
import Icon2010 from './icons/2010_theatre_mask.svg'
import Icon2011 from './icons/2011_fishing_hook.svg'
import Icon2012 from './icons/2012_gallery.svg'
import Icon2013 from './icons/2013_scooter.svg'
import Icon2014 from './icons/2014_tickets.svg'
import Icon2015 from './icons/2015_sewing.svg'
import Icon2016 from './icons/2016_hunt.svg'
import Icon2017 from './icons/2017_club.svg'
import Icon2501 from './icons/2501_hand_biceps.svg'
import Icon2502 from './icons/2502_football.svg'
import Icon2503 from './icons/2503_swimming.svg'
import Icon2504 from './icons/2504_ping_pong.svg'
import Icon2505 from './icons/2505_paint_palette.svg'
import Icon2506 from './icons/2506_fitness.svg'
import Icon2507 from './icons/2507_guitar.svg'
import Icon2508 from './icons/2508_headphones.svg'
import Icon2509 from './icons/2509_brushes_and_pencil.svg'
import Icon2510 from './icons/2510_skating.svg'
import Icon2511 from './icons/2511_drums.svg'
import Icon2512 from './icons/2512_microphone.svg'
import Icon2901 from './icons/2901_christian.svg'
import Icon2902 from './icons/2902_russian.svg'
import Icon2903 from './icons/2903_ramadan.svg'
import Icon2904 from './icons/2904_judaism.svg'
import Icon2905 from './icons/2905_religion.svg'
import Icon2906 from './icons/2906_esoterica.svg'
import Icon3001 from './icons/3001_bus2.svg'
import Icon3002 from './icons/3002_cars.svg'
import Icon3003 from './icons/3003_bicycle.svg'
import Icon3004Motorcycle from './icons/3004_motorcycle.svg'
import Icon3004Taxi from './icons/3004_taxi.svg'
import Icon3005 from './icons/3005_train.svg'
import Icon3006 from './icons/3006_invalid.svg'
import Icon3007 from './icons/3007_metro.svg'
import Icon3008 from './icons/3008_car_repair.svg'
import Icon3009 from './icons/3009_heavy_car.svg'
import Icon3010 from './icons/3010_bus.svg'
import Icon3011 from './icons/3011_car_wash.svg'
import Icon3501 from './icons/3501_gas_station.svg'
import Icon3502 from './icons/3502_work.svg'
import Icon3503 from './icons/3503_parking.svg'
import Icon3504 from './icons/3504_hotel.svg'
import Icon3505 from './icons/3505_gasoline.svg'
import Icon3506 from './icons/3506_marketing.svg'
import Icon4001 from './icons/4001_airport.svg'
import Icon4002 from './icons/4002_beach.svg'
import Icon4501 from './icons/4501_phone2.svg'
import Icon5001 from './icons/5001_coat.svg'
import Icon5002 from './icons/5002_shoe_woman.svg'
import Icon5003 from './icons/5003_portrait_mode.svg'
import Icon5004 from './icons/5004_barbers_scissors.svg'
import Icon5005 from './icons/5005_perfume.svg'
import Icon5006 from './icons/5006_shopping.svg'
import Icon5007 from './icons/5007_cosmetic.svg'
import Icon5008 from './icons/5008_glasses.svg'
import Icon5009 from './icons/5009_rings.svg'
import Icon5010 from './icons/5010_spa.svg'
import Icon5011 from './icons/5011_sneekers.svg'
import Icon5012 from './icons/5012_man_shoe.svg'
import Icon5013 from './icons/5013_jeans.svg'
import Icon5014 from './icons/5014_dress.svg'
import Icon5015 from './icons/5015_lipstick.svg'
import Icon5016 from './icons/5016_manicure.svg'
import Icon5017 from './icons/5017_mirror.svg'
import Icon5400 from './icons/5400_garage.svg'
import Icon5401 from './icons/5401_exterior.svg'
import Icon5402 from './icons/5402_bath.svg'
import Icon5403 from './icons/5403_broom.svg'
import Icon5404 from './icons/5404_paint_roller.svg'
import Icon5405 from './icons/5405_toothbrush.svg'
import Icon5406 from './icons/5406_cleaning.svg'
import Icon5407 from './icons/5407_gas.svg'
import Icon5408 from './icons/5408_radiator.svg'
import Icon5409 from './icons/5409_water.svg'
import Icon5501 from './icons/5501_armchair.svg'
import Icon5502 from './icons/5502_retro_tv.svg'
import Icon5503 from './icons/5503_electrical.svg'
import Icon5504 from './icons/5504_electric_teapot.svg'
import Icon5505 from './icons/5505_laptop.svg'
import Icon5506 from './icons/5506_mobile.svg'
import Icon5507 from './icons/5507_lamp.svg'
import Icon5508 from './icons/5508_coffee_maker.svg'
import Icon5509 from './icons/5509_camera.svg'
import Icon5510 from './icons/5510_potted_plant.svg'
import Icon5511 from './icons/5511_washing_machine.svg'
import Icon6001 from './icons/6001_children.svg'
import Icon6002 from './icons/6002_stroller.svg'
import Icon6003Carousel from './icons/6003_carousel.svg'
import Icon6003Man from './icons/6003_man.svg'
import Icon6004Family from './icons/6004_family.svg'
import Icon6004Woman from './icons/6004_woman.svg'
import Icon6005 from './icons/6005_teddy_bear.svg'
import Icon6501 from './icons/6501_doctor_suitecase.svg'
import Icon6502 from './icons/6502_pill.svg'
import Icon6503 from './icons/6503_doctor.svg'
import Icon6504 from './icons/6504_heart.svg'
import Icon6505 from './icons/6505_smoking.svg'
import Icon6506 from './icons/6506_dantist.svg'
import Icon6507 from './icons/6507_psycology.svg'
import Icon6508 from './icons/6508_pill_glass.svg'
import Icon7001 from './icons/7001_gift.svg'
import Icon7002Charity from './icons/7002_charity.svg'
import Icon7002Literature from './icons/7002_literature.svg'
import Icon7501 from './icons/7501_tree.svg'
import Icon7502 from './icons/7502_campfire.svg'
import Icon7503 from './icons/7503_flower.svg'
import Icon7504 from './icons/7504_tourist.svg'
import Icon7505 from './icons/7505_mountain_courort.svg'
import Icon7901 from './icons/7901_cat.svg'
import Icon7902 from './icons/7902_dog.svg'
import Icon7903 from './icons/7903_fish.svg'
import Icon7904 from './icons/7904_parrot.svg'
import Icon7905 from './icons/7905_reptile.svg'
import Icon7906 from './icons/7906_hamster.svg'
import Icon8001 from './icons/8001_question.svg'
import Icon8002 from './icons/8002_globe.svg'
import Icon8003 from './icons/8003_internet_explorer.svg'
import Icon8004 from './icons/8004_musical.svg'
import Icon8501 from './icons/8501_factory.svg'
import Icon8502 from './icons/8502_training.svg'
import Icon8503 from './icons/8503_handshake.svg'
import Icon9001 from './icons/9001_cash_receiving.svg'
import Icon9002 from './icons/9002_money_bag.svg'
import Icon9003 from './icons/9003_banknotes.svg'
import Icon9004 from './icons/9004_wallet.svg'
import Icon9005 from './icons/9005_gold_bars.svg'
import Icon9006 from './icons/9006_safe.svg'
import Icon9007 from './icons/9007_tax.svg'
import Icon9008 from './icons/9008_give_money.svg'
import Icon9009 from './icons/9009_credit_card.svg'
import Icon9010 from './icons/9010_coin_piggy.svg'
import Icon9011 from './icons/9011_mortgage.svg'
import Icon9012 from './icons/9012_credit.svg'
import Icon9013 from './icons/9013_portfolio.svg'
import Icon9014 from './icons/9014_percentage.svg'
import Icon9015 from './icons/9015_police.svg'
import Icon9501 from './icons/9501_dollar.svg'
import Icon9502 from './icons/9502_euro.svg'
import Icon9503 from './icons/9503_bitcoin.svg'

export const tagIconsSvg: Record<string, string> = {
  '1001_bunch_ingredients': Icon1001,
  '1002_diningroom': Icon1002,
  '1003_bottle_of_water': Icon1003,
  '1004_wine_bottle': Icon1004,
  '1005_doughnut': Icon1005,
  '1006_pizza': Icon1006,
  '1007_hamburger': Icon1007,
  '1008_lunch': Icon1008,
  '1009_deliver': Icon1009,
  '1010_banana': Icon1010,
  '1011_tomato': Icon1011,
  '1012_cocktail': Icon1012,
  '1013_sushi': Icon1013,
  '1014_bakery': Icon1014,
  '1015_corkscrew': Icon1015,
  '1016_coffee_cup': Icon1016,
  '1017_coffee_outdoor': Icon1017,
  '1018_meat': Icon1018,
  '1019_milk': Icon1019,
  '2001_beer': Icon2001,
  '2002_dancing': Icon2002,
  '2003_film_reel': Icon2003,
  '2004_champagne': Icon2004,
  '2005_birthday': Icon2005,
  '2006_candy': Icon2006,
  '2007_controller': Icon2007,
  '2008_books': Icon2008,
  '2009_dice': Icon2009,
  '2010_theatre_mask': Icon2010,
  '2011_fishing_hook': Icon2011,
  '2012_gallery': Icon2012,
  '2013_scooter': Icon2013,
  '2014_tickets': Icon2014,
  '2015_sewing': Icon2015,
  '2016_hunt': Icon2016,
  '2017_club': Icon2017,
  '2501_hand_biceps': Icon2501,
  '2502_football': Icon2502,
  '2503_swimming': Icon2503,
  '2504_ping_pong': Icon2504,
  '2505_paint_palette': Icon2505,
  '2506_fitness': Icon2506,
  '2507_guitar': Icon2507,
  '2508_headphones': Icon2508,
  '2509_brushes_and_pencil': Icon2509,
  '2510_skating': Icon2510,
  '2511_drums': Icon2511,
  '2512_microphone': Icon2512,
  '2901_christian': Icon2901,
  '2902_russian': Icon2902,
  '2903_ramadan': Icon2903,
  '2904_judaism': Icon2904,
  '2905_religion': Icon2905,
  '2906_esoterica': Icon2906,
  '3001_bus2': Icon3001,
  '3002_cars': Icon3002,
  '3003_bicycle': Icon3003,
  '3004_motorcycle': Icon3004Motorcycle,
  '3004_taxi': Icon3004Taxi,
  '3005_train': Icon3005,
  '3006_invalid': Icon3006,
  '3007_metro': Icon3007,
  '3008_car_repair': Icon3008,
  '3009_heavy_car': Icon3009,
  '3010_bus': Icon3010,
  '3011_car_wash': Icon3011,
  '3501_gas_station': Icon3501,
  '3502_work': Icon3502,
  '3503_parking': Icon3503,
  '3504_hotel': Icon3504,
  '3505_gasoline': Icon3505,
  '3506_marketing': Icon3506,
  '4001_airport': Icon4001,
  '4002_beach': Icon4002,
  '4501_phone2': Icon4501,
  '5001_coat': Icon5001,
  '5002_shoe_woman': Icon5002,
  '5003_portrait_mode': Icon5003,
  '5004_barbers_scissors': Icon5004,
  '5005_perfume': Icon5005,
  '5006_shopping': Icon5006,
  '5007_cosmetic': Icon5007,
  '5008_glasses': Icon5008,
  '5009_rings': Icon5009,
  '5010_spa': Icon5010,
  '5011_sneekers': Icon5011,
  '5012_man_shoe': Icon5012,
  '5013_jeans': Icon5013,
  '5014_dress': Icon5014,
  '5015_lipstick': Icon5015,
  '5016_manicure': Icon5016,
  '5017_mirror': Icon5017,
  '5400_garage': Icon5400,
  '5401_exterior': Icon5401,
  '5402_bath': Icon5402,
  '5403_broom': Icon5403,
  '5404_paint_roller': Icon5404,
  '5405_toothbrush': Icon5405,
  '5406_cleaning': Icon5406,
  '5407_gas': Icon5407,
  '5408_radiator': Icon5408,
  '5409_water': Icon5409,
  '5501_armchair': Icon5501,
  '5502_retro_tv': Icon5502,
  '5503_electrical': Icon5503,
  '5504_electric_teapot': Icon5504,
  '5505_laptop': Icon5505,
  '5506_mobile': Icon5506,
  '5507_lamp': Icon5507,
  '5508_coffee_maker': Icon5508,
  '5509_camera': Icon5509,
  '5510_potted_plant': Icon5510,
  '5511_washing_machine': Icon5511,
  '6001_children': Icon6001,
  '6002_stroller': Icon6002,
  '6003_carousel': Icon6003Carousel,
  '6003_man': Icon6003Man,
  '6004_family': Icon6004Family,
  '6004_woman': Icon6004Woman,
  '6005_teddy_bear': Icon6005,
  '6501_doctor_suitecase': Icon6501,
  '6502_pill': Icon6502,
  '6503_doctor': Icon6503,
  '6504_heart': Icon6504,
  '6505_smoking': Icon6505,
  '6506_dantist': Icon6506,
  '6507_psycology': Icon6507,
  '6508_pill_glass': Icon6508,
  '7001_gift': Icon7001,
  '7002_charity': Icon7002Charity,
  '7002_literature': Icon7002Literature,
  '7501_tree': Icon7501,
  '7502_campfire': Icon7502,
  '7503_flower': Icon7503,
  '7504_tourist': Icon7504,
  '7505_mountain_courort': Icon7505,
  '7901_cat': Icon7901,
  '7902_dog': Icon7902,
  '7903_fish': Icon7903,
  '7904_parrot': Icon7904,
  '7905_reptile': Icon7905,
  '7906_hamster': Icon7906,
  '8001_question': Icon8001,
  '8002_globe': Icon8002,
  '8003_internet_explorer': Icon8003,
  '8004_musical': Icon8004,
  '8501_factory': Icon8501,
  '8502_training': Icon8502,
  '8503_handshake': Icon8503,
  '9001_cash_receiving': Icon9001,
  '9002_money_bag': Icon9002,
  '9003_banknotes': Icon9003,
  '9004_wallet': Icon9004,
  '9005_gold_bars': Icon9005,
  '9006_safe': Icon9006,
  '9007_tax': Icon9007,
  '9008_give_money': Icon9008,
  '9009_credit_card': Icon9009,
  '9010_coin_piggy': Icon9010,
  '9011_mortgage': Icon9011,
  '9012_credit': Icon9012,
  '9013_portfolio': Icon9013,
  '9014_percentage': Icon9014,
  '9015_police': Icon9015,
  '9501_dollar': Icon9501,
  '9502_euro': Icon9502,
  '9503_bitcoin': Icon9503,
}
